import { render } from "./FilesCountComponent.vue?vue&type=template&id=a85c0d9a&scoped=true"
import script from "./FilesCountComponent.vue?vue&type=script&lang=js"
export * from "./FilesCountComponent.vue?vue&type=script&lang=js"

import "./FilesCountComponent.vue?vue&type=style&index=0&id=a85c0d9a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85c0d9a"]])

export default __exports__